import { render } from "./SideOver.vue?vue&type=template&id=1c70bc3a&scoped=true"
import script from "./SideOver.vue?vue&type=script&lang=js"
export * from "./SideOver.vue?vue&type=script&lang=js"

import "./SideOver.vue?vue&type=style&index=0&id=1c70bc3a&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c70bc3a"]])

export default __exports__